import { ComponentBase } from "common";
import { Input, Output, EventEmitter, Directive } from "@angular/core";
import { ProtocolSettings } from "DiscoveryEngine.TS/Protocols";
import { Changeable } from "common";
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';


@Directive()
export abstract class ProtocolSettingsComponent<T extends ProtocolSettings>
	extends ComponentBase implements Changeable {

	@Input()
	public Settings: T;

	@Input()
	public AllowShowChars: boolean;

	@Output()
	public onApply: EventEmitter<any>;

	public SettingsForm: UntypedFormGroup;
	public ShowChars: UntypedFormControl;

	public PasswordInputType = "password";

	constructor() {
		super();

		this.Settings = null;
		this.AllowShowChars = false;
		this.onApply = new EventEmitter<any>();
	}

	protected abstract BuildForm(): void;

	public get tempChanges(): boolean {
		return this.SettingsForm.dirty;
	}

	public get tempChangesValid(): boolean {
		return this.SettingsForm.valid;
	}

	public abstract get invalidTempChanges(): string[];

	public abstract applyTempChanges(): void;

	public discardTempChanges(): void {
		this.BuildForm();
	}

	protected OnApplyTempChanges(): void {
		this.onApply.emit();
	}

	public onPasswordKeyDownHandler(event: any, pwFieldName: string): void {
		let pwFieldChangedName = pwFieldName + "Changed";
		let pwFieldConfirmName = pwFieldName + "Confirm";

		if (!this[pwFieldChangedName]) {
			this[pwFieldChangedName] = true;

			this[pwFieldName].setValue('');
			this[pwFieldName].markAsDirty();

			if (this[pwFieldConfirmName] !== undefined) {
				this[pwFieldConfirmName].setValue('');
				this[pwFieldConfirmName].markAsDirty();
			}
		}
	}

	public ToggleShowChars(): void {
		if (this.PasswordInputType == "password") {
			this.PasswordInputType = "text";
		}
		else {
			this.PasswordInputType = "password";
		}

		// Changing the value of this checkbox should not constitute a change to the target
		this.ShowChars.markAsPristine();
	}

}